const routes = [
  {
    path: '/area',
    name: 'area',
    component: () => import('@src/modules/area/AreaManagement'),
    meta: {
      requireAuth: false,
      routerAlive: false
    }
  }
]

export default routes
